/**
 * Terminal widget preset — an interactive xterm.js terminal tunneling into the
 * canvas's e2b sandbox. Fill-mode (scaleContent: false) so the terminal reflows to
 * the node size; multiple widgets share one container as separate tmux sessions.
 */
import type { WidgetPreset } from "../types";
import { TerminalToolbar } from "./TerminalToolbar";
import { TerminalWidget } from "./TerminalWidget";
import { DEFAULT_TERMINAL_THEME_ID } from "./themes";

const PREVIEW_HTML = `
<div style="width:680px;height:420px;background:#1e1e1e;border-radius:10px;overflow:hidden;font-family:ui-monospace,Menlo,monospace;box-shadow:0 2px 12px rgba(0,0,0,.18)">
  <div style="height:34px;display:flex;align-items:center;gap:8px;padding:0 14px;background:#2a2a2a">
    <span style="width:12px;height:12px;border-radius:50%;background:#ff5f56"></span>
    <span style="width:12px;height:12px;border-radius:50%;background:#ffbd2e"></span>
    <span style="width:12px;height:12px;border-radius:50%;background:#27c93f"></span>
    <span style="margin-left:8px;color:#888;font-size:13px">zsh — canvas</span>
  </div>
  <div style="padding:16px;color:#d4d4d4;font-size:14px;line-height:1.7">
    <div><span style="color:#27c93f">&#10140;</span> <span style="color:#11a8cd">~</span> ls /mnt/canvas-files</div>
    <div style="color:#9aa0a6">notes.md&nbsp;&nbsp;report.pdf&nbsp;&nbsp;data.csv</div>
    <div><span style="color:#27c93f">&#10140;</span> <span style="color:#11a8cd">~</span> <span style="display:inline-block;width:8px;height:16px;vertical-align:middle;background:#d4d4d4"></span></div>
  </div>
</div>`;

export const TERMINAL: WidgetPreset = {
  id: "terminal",
  label: "Terminal ⌲",
  defaultWidth: 680,
  defaultHeight: 448, // 420 terminal + 28px (h-7) title bar
  component: TerminalWidget,
  toolbarSlot: TerminalToolbar,
  resizable: {
    minWidth: 360,
    minHeight: 248, // 220 terminal + 28px (h-7) title bar
    scaleContent: false, // TerminalWidget fills via w-full/h-full + FitAddon
  },
  previewHtml: PREVIEW_HTML,
  initialData: {
    theme: DEFAULT_TERMINAL_THEME_ID,
  },
};
